import { Location } from '@angular/common';
import { Component, DestroyRef, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';
import { ApplicationUser } from '../../../../../core/shared/models/application.user.model';
import { applicationUserState } from '../../../../../core/shared/states/application.user.state';
import { GetApplicationUsers } from '../../../../../core/shared/actions/application.user.actions';
import { ApplicationUserModalComponent } from '../../modals/application-user-modal/application-user-modal.component';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
  standalone: true,
  imports: [
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    LoadingSpinnerComponent,
    MatInputModule,
    MatIcon,
    MatButton,
    MatIconButton,
  ],
})
export class UsersListComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  public dataSource = new MatTableDataSource<ApplicationUser>();
  public displayedColumns = ['icon', 'SK', 'receiveNotifications', 'actions'];
  public loading = true;
  public applicationUser!: ApplicationUser;
  public userCount = 0;
  public applicationName: any;
  private paginator!: MatPaginator;
  private sort!: MatSort;
  public readonly applicationUsers: Observable<ApplicationUser[]>;

  constructor(
    private store: Store,
    private location: Location,
    private route: ActivatedRoute,
    public modalService: NgbModal
  ) {
    this.applicationName = this.route.snapshot.paramMap.get('Application_Name');
    this.store.dispatch(new GetApplicationUsers(this.applicationName));
    this.applicationUsers = this.store.select(applicationUserState.getApplicationUsersList);
  }

  ngOnInit() {
    this.applicationUsers.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.dataSource.data = data;
      this.userCount = data.length;
      this.loading = false;
    });
  }

  openModal(selectedUser: ApplicationUser, formMode: string, applicationName: string, editUser: boolean) {
    const modalRef = this.modalService.open(ApplicationUserModalComponent, { size: 'lg' });
    modalRef.componentInstance.user = selectedUser;
    modalRef.componentInstance.applicationName = applicationName;
    modalRef.componentInstance.editUser = editUser;
    modalRef.componentInstance.formMode = formMode;
  }

  back(): void {
    this.location.back();
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
